module.exports = __webpack_public_path__ + "img/ywtxone.4fc0c38e.png";